<template>
  <!--
    Transición de alto reutilizable para acordeones (ACHIEVERY-1363, Etapas 2 y 5).
    Anima height 0 <-> auto midiendo scrollHeight, con fade del contenido en paralelo.
    Envolver UN solo elemento
    controlado por v-if (o v-show). El elemento animado debe ser display:block.
    Uso:
      <CollapseTransition>
        <div v-if="open">...</div>
      </CollapseTransition>
  -->
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="reset"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="reset"
  >
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'CollapseTransition',
  props: {
    // Duración de la animación en ms.
    duration: {
      type: Number,
      default: 300
    }
  },
  methods: {
    setTransition(el) {
      el.style.overflow = 'hidden';
      el.style.transitionProperty = 'height, opacity';
      el.style.transitionDuration = `${this.duration}ms`;
      el.style.transitionTimingFunction = 'ease';
    },
    beforeEnter(el) {
      this.setTransition(el);
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
    },
    beforeLeave(el) {
      this.setTransition(el);
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
      // fuerza reflow para que la animación arranque desde la altura actual
      el.offsetHeight; // eslint-disable-line no-unused-expressions
    },
    leave(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    reset(el) {
      el.style.height = '';
      el.style.opacity = '';
      el.style.overflow = '';
      el.style.transitionProperty = '';
      el.style.transitionDuration = '';
      el.style.transitionTimingFunction = '';
    }
  }
};
</script>
